import { RootScopeEvents } from '../../../../common/services/root-scope-types';
import { ErrorTrack } from '../error.track';
export default class MediaStreamSubscribeErrorTrack extends ErrorTrack {
    start() {
        this.$rootScope.$on(RootScopeEvents.STREAM.SUBSCRIPTION_ERROR, (_e, streamError) => {
            this.trackSegment({
                errorType: 'Media Stream Subscriber Error',
                errorSubtype: streamError.event.name,
            });
        });
    }
}
